import { useNavigate } from "react-router-dom";
import { Tabs } from "../../utils/TabbarData";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { MdClose, MdMenu } from "react-icons/md";
import LanguageSelector from "../LanguageSelector";

function TabNavbar({
  id,
  handleSaveAndPublish,
  isDisable,
  isLoading,
  tabs,
  selectedTabId,
  doesShow,
  type,
}: {
  id: string;
  handleSaveAndPublish?: () => void;
  isDisable?: boolean;
  isLoading?: boolean;
  tabs: Tabs[];
  selectedTabId?: number;
  doesShow?: boolean;
  type?: string;
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [drawerOpen, setDrawerOpen] = useState(false); // State for drawer visibility

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <div className="w-full">
      {/* Desktop Tabs */}
      <div className="hidden lg:flex items-center justify-between gap-5 w-full">
        <div className="flex items-center justify-start gap-5 w-full">
          {tabs.map((item) => (
            <div
              key={item.id}
              className={`flex items-center justify-start gap-2 cursor-pointer group ${
                item.id === selectedTabId && "underline underline-offset-2"
              } duration-200 transition-all decoration-[#752938]`}
              onClick={() => {
                if (item.title === "My Training History") {
                  if (item.url !== "#") {
                    window.open(item.url, "_blank");
                  }
                } else {
                  if (item.url !== "#") {
                    navigate(item.url);
                  }
                }
              }}
            >
              <div>{item.icon}</div>
              <p className="text-sm text-[#752938]">{t(item.title)}</p>
            </div>
          ))}
        </div>
        {id === "seat-allocation" && doesShow && (
          <div className="flex items-center gap-5 w-full justify-end">
            <button
              disabled={isDisable || isLoading}
              onClick={() => handleSaveAndPublish && handleSaveAndPublish()}
              className={`py-2 px-4 font-semibold bg-[#961e38] text-white ${
                isDisable ? "cursor-not-allowed" : "cursor-pointer"
              }`}
            >
              {isLoading
                ? `${t("Saving")}...`
                : isDisable
                ? t("Training Published")
                : t("Save & Publish Training")}
            </button>
          </div>
        )}
      </div>

      {/* Mobile Drawer */}
      <div className="lg:hidden">
        <div className="flex items-center w-full pb-4 border-b border-gray-400">
          <button
            onClick={toggleDrawer}
            className="text-[#961e38] pr-4 cursor-pointer"
          >
            <MdMenu size={30} />
          </button>
          <h5>{t(`${type}`)}</h5>
        </div>

        {/* Drawer */}
        {drawerOpen && (
          <div className="absolute top-0 left-0 w-full h-full bg-white z-50 shadow-lg p-6">
            <div className="flex justify-between items-center">
              <button onClick={toggleDrawer}>
                <MdClose size={30} />
              </button>
            </div>
            <div className="flex flex-col items-start gap-8 mt-6">
              {tabs.map((item) => (
                <div
                  key={item.id}
                  className={`flex items-center justify-start gap-2 cursor-pointer group ${
                    item.id === selectedTabId && "underline underline-offset-2"
                  } duration-200 transition-all decoration-[#752938]`}
                  onClick={() => {
                    if (item.title === "My Training History") {
                      if (item.url !== "#") {
                        window.open(item.url, "_blank");
                      }
                    } else {
                      if (item.url !== "#") {
                        navigate(item.url);
                      }
                    }
                  }}
                >
                  <div>{item.icon}</div>
                  <p className="text-sm text-[#752938]">{t(item.title)}</p>
                </div>
              ))}
              <LanguageSelector />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TabNavbar;
